import { Component, ChangeDetectionStrategy, Input, OnInit, ViewChild } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Store } from '../../models/store';
import { MatBottomSheetRef, MatBottomSheet } from '@angular/material';
import { StoreService } from '../../services/store.service';
import { StoreSelectorService } from '../../services/storeselector.service';
import { AuthService } from '../../services/auth.service';

// Store Selector Bottom Sheet
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'store-selector',
  templateUrl: 'store-selector.component.html',
  styleUrls: ['./store-selector.component.scss']
})
export class StoreSelectorComponent implements OnInit {
  constructor(private _authService: AuthService,
              private bottomSheetRef: MatBottomSheetRef<StoreSelectorComponent>,
              private _storeService: StoreService,
              private _storeSelectorService: StoreSelectorService) {}
  
  @Input()
  public $stores = new Subject<Store[]>();
  stores: Store[] = [];
  @ViewChild('filterField') filterField: any;

  disableClose: boolean;
  isLoadingResults: boolean = true;
  hasError: boolean = false;
  errorMessage: string = "";
  filter: string = "";

  ngOnInit() {
    console.log("disableclose", this.bottomSheetRef.containerInstance.bottomSheetConfig.disableClose);
    this.disableClose = this.bottomSheetRef.containerInstance.bottomSheetConfig.disableClose;
    this.getStores();
  }

  ngAfterViewInit() {
		setTimeout(() => {
			this.filterField.valueAccessor._elementRef.nativeElement.focus();
		}, 500);
	}

  getStores() {
    this.isLoadingResults = true;
    this.hasError = false;

    this._storeService.getStores().then((storeRequest: Observable<Store[]>) => {
      storeRequest.subscribe((stores: Store[]) => {
        // Sort stores alphabetically
        stores = stores.sort((a, b) => {
          const aName = a.name;
          const bName = b.name;
          if (aName < bName) {
            return -1;
          }
          if (aName > bName) {
            return 1;
          }
          return 0;
        });
        // Update stores list
        this.stores = stores;
        // this.$stores.next(this.stores);
        this.applyFilter();
        // On success, Disable loading bar
        this.isLoadingResults = false;
        // On success, Disable error message
        this.hasError = false;
      }, err => {
        // On error, Show no data
        this.stores = [];
        // this.$stores.next(this.stores);
        this.applyFilter();
        // On error, Disable loading bar
        this.isLoadingResults = false;
        // On error, Set user facing error message to error from event.service
        this.errorMessage = err;
        // On error, Show loading message
        this.hasError = true;
      })
    })
  }

  close() {
    this.bottomSheetRef.dismiss();
  }

  selectStore(event: MouseEvent, store: Store): void {
    console.log(store);
    this._storeSelectorService.setSelectedStore(store);
    this.bottomSheetRef.dismiss();
    event.preventDefault();
  }

  applyFilter() {
    let filteredStores = this.stores.filter(s => s.name.toLowerCase().indexOf(this.filter.toLowerCase()) > -1);
    this.$stores.next(filteredStores);
  }

  clearFilter() {
    this.filter = "";
    this.$stores.next(this.stores);
  }

  // Allow users to log out if they cannot get past the Store Selector
  logout(): void {
    this._authService.Logoff();
  }
}